<template>
  <v-select v-model="selectedEndpoints" :filled="!solo" :solo="solo" :hide-details="!solo" :single-line="solo" :multiple="multiple"
    :items="actuatorList" :rules="rules" :label="label" :clearable="clearable" prepend-inner-icon="mdi-nfc-variant">
    <template v-slot:item="{ item, attrs }">
      <v-list-item-avatar tile>
        <img style="width:20px;height:20px" src="@/assets/icon/curtain/curtain_up_50.svg" v-if="item.value=='smart-button-curtain-1'" />
        <v-icon class="primary--text" v-else>{{ actuator[item.value].icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title :class="attrs.inputValue?'primary--text':'black--text'">{{item.text}}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action :class="attrs.inputValue?'primary--text':'grey--text'">{{$t(`type.${actuator[item.value].type}`)}}</v-list-item-action>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'EndpointSelector',
  props: {
    value: {
      type: Array,
    },
    rules: {
      type: Array
    },
    label: {
      type: String
    },
    solo: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    availableEndpoints: {
      type: Array
    },
    config: {
      type: Object
    }
  },
  data() {
    return {
      actuator: {
        "onboard-main-light": {type: 'LIGHT', icon: 'mdi-lightbulb'}, 
        "external-light-1": {type: 'LIGHT', icon: 'mdi-lightbulb'}, 
        "onboard-main-fan": {type: 'FAN', icon: 'mdi-fan'}, 
        "smart-button-curtain-1": {type: 'CURTAIN', icon: ""},
        "smart-relay-4": {type: 'SWITCH', icon: "mdi-toggle-switch"}
      }
    }
  },
  computed: {
    selectedEndpoints: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    actuatorList() {
      let list = Object.keys(this.actuator).filter(a => this.availableEndpoints.includes(a));
      return list.map(id => ({
        text: (this.config || {})[id] ? this.config[id].name :this.$t(`type.${this.actuator[id].type}`),
        value: id
      }));
    }
  }
}
</script>
